import { v4 } from "uuid"
import { DecisionReason, InAppMessage, HackleEvent } from "../../../core/internal/model/model"
import { Identifiers } from "../../../core/internal/model/model"
import { InAppMessageDelayStorageEntity } from "../storage/InAppMessageDelayStorage"
import { InAppMessageTrigger } from "../trigger/InAppMessageTrigger"
import { InAppMessageScheduleRequest } from "./InAppMessageScheduleRequest"
import { InAppMessageScheduleType } from "./InAppMessageScheduleType"

export class InAppMessageSchedule {
  constructor(
    public readonly dispatchId: string,
    public readonly inAppMessageKey: number,
    public readonly identifiers: Identifiers,
    public readonly time: InAppMessageScheduleTime,
    public readonly reason: DecisionReason,
    public readonly eventBasedContext: InAppMessageEventBasedContext
  ) {}

  toRequest(type: InAppMessageScheduleType, requestedAt: number): InAppMessageScheduleRequest {
    return new InAppMessageScheduleRequest(this, type, requestedAt)
  }

  static create(trigger: InAppMessageTrigger): InAppMessageSchedule {
    return new InAppMessageSchedule(
      v4(),
      trigger.inAppMessage.key,
      trigger.event.user.identifiers,
      InAppMessageScheduleTime.of(trigger.inAppMessage, trigger.event.timestamp),
      trigger.reason,
      new InAppMessageEventBasedContext(trigger.event.insertId, trigger.event.event)
    )
  }

  static fromDelayStorageEntity(delay: InAppMessageDelayStorageEntity, delayRestoredAt: number): InAppMessageSchedule {
    return new InAppMessageSchedule(
      delay.schedule.dispatchId,
      delay.schedule.inAppMessageKey,
      delay.schedule.identifiers,
      new InAppMessageScheduleTime(delayRestoredAt, delay.schedule.time.deliverAt),
      // Persisted by a possibly older/newer SDK; unknown reasons degrade to UNKNOWN.
      DecisionReason.from(delay.schedule.reason),
      delay.schedule.eventBasedContext
    )
  }
}

export class InAppMessageScheduleTime {
  constructor(public readonly startedAt: number, public readonly deliverAt: number) {}

  delayMillis(at: number): number {
    return this.deliverAt - at
  }

  static of(inAppMessage: InAppMessage, startedAt: number): InAppMessageScheduleTime {
    return new InAppMessageScheduleTime(startedAt, inAppMessage.eventTrigger.delay.deliverAt(startedAt))
  }
}

export class InAppMessageEventBasedContext {
  constructor(public readonly insertId: string, public readonly event: HackleEvent) {}
}
